"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loanDetailSchema = void 0;
exports.loanDetailSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [],
    properties: {
        approvedLenderCode: {
            type: ['string', 'null'],
            minLength: 5,
            maxLength: 5,
            errorMessage: 'should be a string of length 5 characters or null',
        },
        chequeCancelledDate: {
            type: ['string', 'null'],
            oneOf: [
                // allow empty string
                {
                    maxLength: 0,
                },
                {
                    format: 'date',
                },
            ],
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        claimCancelledDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        claimReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        claimStatusTypeCode: {
            type: ['integer', 'null'],
            errorMessage: 'should be an integer or null',
        },
        claimTypeIndicator: {
            type: ['integer', 'null'],
            errorMessage: 'should be an integer or null',
        },
        legacyClaimIndicator: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be a boolean or null',
        },
        lenderLoanAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        loanAccountStatusCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        loanApprovalDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        loanIndemnifiedIndicator: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters or null',
        },
        loanTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        loanPurposeTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters or null',
        },
        premiumDueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        productCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters or null',
        },
    },
};
